import { useContext } from "react";
import { DataKindMaintenancePageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(
    DataKindMaintenancePageContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
